import { client } from './automaticCurrencyConversion';

interface CustomerAddress {
  city?: string;
  country_code: string;
  postcode?: string;
  state?: string;
  street?: string;
}

export interface Customer {
  address?: CustomerAddress;
  business_name?: string;
  email?: string;
  first_name?: string;
  last_name?: string;
  merchant_customer_id?: string;
  phone_number?: string;
}

export const getCustomer = async (clientSecret: string, customerId: string): Promise<Customer> => {
  const { data } = await client(clientSecret).get(`/v1/pa/customers/${customerId}`);
  return data;
};
